import { type ReactElement } from 'react'
import { type TeamId } from '@terros/common'
import { useToastError } from '@hooks'
import { useTranslation, useUpdateTeam } from '@front/model'
import { PermissionTooltip } from '../permissions'
import { TButton } from '../buttons'

export const RestoreTeamButton = ({ teamId }: { teamId: TeamId }): ReactElement => {
  const { t } = useTranslation()
  const { update, isUpdating, error } = useUpdateTeam()
  useToastError(error)

  const restore = async (): Promise<void> => {
    await update({ teamId, isDeleted: false })
  }

  return (
    <PermissionTooltip permissionType='team:update' targetId={teamId}>
      <TButton icon='restore_from_trash' loading={isUpdating} onClick={restore}>
        {t('Restore')}
      </TButton>
    </PermissionTooltip>
  )
}
